import { render, staticRenderFns } from "./RatingListView.vue?vue&type=template&id=f8a40808"
import script from "./RatingListView.vue?vue&type=script&lang=js"
export * from "./RatingListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports